import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import renderHTML from 'react-render-html';

function Podcast({ podcasts }) {  
    
    return (
        <div className="grid">
            {podcasts.map(podcast => (
                <div className="grid-item cat-" key={podcast.id}>
                    <div className="grid-item-inner">
                        <Link to={podcast.link.replace("/index.php","")} className="grid-item-link item">
                            <div className="grid-item-card">
                                <div className="grid-item-picture">
                                    <img src={podcast.acf.programme_visuel.url} alt={podcast.title.rendered} />
                                </div>
                                <div className="grid-item-data">
                                    {podcast.acf.podcast_nom && (
                                        <div className="news-item-category-label">{podcast.acf.podcast_nom}</div>
                                    )}
                                    {moment(podcast.acf.date_premiere_diffusion, 'YYYYMMDD').format('DD/MM/YYYY')}
                                    <h3>{renderHTML(podcast.title.rendered)}</h3>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Podcast